export default "__VITE_ASSET__DLo_cN3K__"